import React, { useEffect } from "react";
import { Button, Iconography, IconographySizes, Loader, LoaderSizes } from "@hid-galaxy-ui/galaxy-react";
import { IconButton, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../../../redux";
import { PartnerRegionalMultiplierListType } from "../../../../../../redux/slices/partner-program/regional-multipliers/Types";
import { formatDate } from "../tier-management";
import { AddPartnerRegionalMultiplierDetailsType, addPartnerRegionalMultiplierSagaAction, deletePartnerRegionalMultiplierListSagaAction, getPartnerRegionalMultiplierListSagaAction, updatePartnerRegionalMultiplierDetailsType, updatePartnerRegionalMultiplierListSagaAction } from "../../../../../../redux/saga/partner-program/regional-multipliers/saga-actions";
import PartnerregionMultiplierModal from "./partnerRegionalModal";
import DeleteModal from "../../../../../../common/components/DeleteModal";

type Props = {
  activeTab: number;
  partnerProgramId: number;
  readOnly?: boolean;
};

const PartnerRegionalMultipliers: React.FC<Props> = ({
  activeTab,
  partnerProgramId,
  readOnly = false,
}) => {
  const dispatch = useAppDispatch();


  //comment for static data
  const { partnerRegionalMultiplierList,

    status: {
      deletepartnerRegionalListLoading,
      partnerRegionalListLoading
    }
  } = useAppSelector((state) => state.partner_regionalmultiplier);

  const [showAdd, setShowAdd] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const [editregion, setEditregion] = React.useState<PartnerRegionalMultiplierListType[number] | null>(null);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [deleteTierId, setDeleteTierId] = React.useState<number | null>(null);
  React.useEffect(() => {
    if (activeTab === 3) {
      dispatch(getPartnerRegionalMultiplierListSagaAction(partnerProgramId));
    }
  }, [activeTab, dispatch, partnerProgramId]);

  const onAddClick = () => setShowAdd(true);

  const onEditClick = (region: PartnerRegionalMultiplierListType[number]) => {
    setEditregion(region);
    setShowEdit(true);
  };

  // const onDeleteClick = (id: number) => {
  //   dispatch(deletePartnerRegionalMultiplierListSagaAction(id));
  //   dispatch(getPartnerRegionalMultiplierListSagaAction(partnerProgramId));
  // };


  const onDeleteClick = (id: number) => {
    setDeleteModalOpen(true);
    setDeleteTierId(id);
    //dispatch(deleteEngagementListSaga(id));
    //dispatch(getPartnerEngagementConfigurationListSagaAction());
  };

  const onDeleteEngagement = (id: number) => {

    dispatch(deletePartnerRegionalMultiplierListSagaAction(id));
    // dispatch(getPartnerTierListSagaAction(PARTNER_PROGRAM_ID));
  };

  useEffect(() => {
    if (!deletepartnerRegionalListLoading) {
      setDeleteModalOpen(false);
    }

  }, [deletepartnerRegionalListLoading])

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "12px", marginBottom: "12px" }}>
        <div>
          <h1 style={{ fontFamily: "Roboto", fontStyle: "normal", fontWeight: 500, fontSize: "16px", lineHeight: "20px", letterSpacing: "0.2px", color: "#0A0A0A", marginBottom: "5px" }}>Regional Modifier</h1>
          <Typography variant="h4" style={{ fontFamily: "Roboto", fontStyle: "normal", fontWeight: 400, fontSize: "14px", lineHeight: "18px", letterSpacing: "0.2px", color: "#4A5565" }}>Point multipliers for different regions</Typography>
        </div>
        <Button
          variant="primary"
          label="Add Modifier"
          icon={<Iconography icon="plus" />}
          onClick={onAddClick}
          disabled={readOnly}
        />
      </div>
      <div className="pp-table" role="table" aria-label="Regional Multipliers">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr 1.5fr 120px",
            gap: "8px",
            padding: "8px 16px",
            background: "#F9FAFB",
            border: "1px solid #E5E7EB",
            borderBottom: "1px solid #E5E7EB",
            borderRadius: "6px 6px 0 0",
            fontFamily: "'Roboto'",
            fontWeight: 500,
            color: "#374151"
          }}
          role="rowgroup">
          <div className="pp-th col-region-type" role="columnheader">Country</div>
          <div className="pp-th col-count" role="columnheader">Region Name</div>
          <div className="pp-th col-points" role="columnheader">Region Code</div>
          <div className="pp-th col-created" role="columnheader">Multiplier Value</div>
          <div className="pp-th col-created" role="columnheader">Created At</div>
          <div className="pp-th col-actions" role="columnheader">Actions</div>
        </div>
        <div className="pp-table-body" role="rowgroup">





          {partnerRegionalListLoading ? (
            <div
              style={{
                padding: "16px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Loader variant={LoaderSizes.medium} />
            </div>
          ) : (partnerRegionalMultiplierList ?? []).length === 0 ? (
            <div
              style={{
                padding: "16px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              No Regional Modifier found
            </div>
          ) :




            (
              (partnerRegionalMultiplierList ?? []).map((region) => {
                return (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr 1.5fr 120px",
                      gap: "8px",
                      alignItems: "center",
                      padding: "16px",
                      minHeight: "48px",
                      borderTop: "2px solid #F3F4F6",
                    }}
                    role="row" key={region.ID}>
                    <div className="pp-td col-region-type" 
                     style={{ paddingLeft: "1px" }}
                    role="cell">
                      {region.country}
                    </div>
                    <div className="pp-td col-count" role="cell">
                      {region.region}
                    </div>
                    <div className="pp-td col-points region-code-badge" role="cell">
                      {region.region_code}
                    </div>
                    <div className="pp-td col-points" role="cell">
                      {Number(region.value).toLocaleString()}
                    </div>
                    <div className="pp-td col-created" role="cell">
                      {formatDate(region.created_at)}
                    </div>
                    <div className="pp-td col-actions" role="cell">
                      <IconButton
                        aria-label={`Edit ${region.country}`}
                        onClick={() => onEditClick(region)}
                        disabled={readOnly}
                      >
                        <Iconography icon="pen" size={IconographySizes.Small} />
                      </IconButton>
                      <IconButton
                        aria-label={`Delete ${region.country}`}
                        onClick={() => onDeleteClick(region.ID)}
                        disabled={readOnly}
                      >
                        <Iconography
                          icon="trashCan"
                          size={IconographySizes.Small}
                        />
                      </IconButton>
                    </div>
                  </div>
                );
              })
            )}
        </div>
      </div>
      {showAdd && (
        <PartnerregionMultiplierModal
          mode="add"
          open
          onClose={() => setShowAdd(false)}
          onSubmit={(payload: AddPartnerRegionalMultiplierDetailsType) => {

            const clean: AddPartnerRegionalMultiplierDetailsType = {
              ID: payload.ID,
              country: payload.country ?? "",
              region: payload.region ?? "",
              value: Number.isFinite(payload.value) ? payload.value : 0,
              region_code: payload.region_code ?? "",
            };
            if (!clean.country) {
              console.error("Country field is required.");
              return;
            }

            dispatch(addPartnerRegionalMultiplierSagaAction(clean));
            //setShowAdd(false);
            dispatch(getPartnerRegionalMultiplierListSagaAction(partnerProgramId));
          }}
        />
      )}

      {showEdit && editregion && (
        <PartnerregionMultiplierModal
          onClose={() => {
            setShowEdit(false);
            setEditregion(null);
          }}
          onSubmit={(payload: updatePartnerRegionalMultiplierDetailsType) => {
            const clean = {
              ...payload,
              ID: payload.ID,
              country: payload.country ?? "",
              region: payload.region ?? "",
              value: Number.isFinite(payload.value) ? payload.value : 0,
              region_code: payload.region_code ?? "",
            } as any;
            dispatch(updatePartnerRegionalMultiplierListSagaAction(clean));
            //setShowEdit(false);
            //setEditregion(null);
            dispatch(getPartnerRegionalMultiplierListSagaAction(partnerProgramId));
          }}
          mode="edit"
          open
          initialValue={{
            ID: editregion.ID,
            country: editregion.country,
            region: editregion.region,
            value: Number(editregion.value) as any,
            region_code: editregion.region_code,
          }}
        />
      )}

      {deleteModalOpen && deleteTierId && (
        <DeleteModal
          setDeleteOpen={setDeleteModalOpen}
          onDeleteButtonClick={() => onDeleteEngagement(deleteTierId)}
          deleteButtonLoading={deletepartnerRegionalListLoading}
          optionalHeader="Delete Regional Modifier"
          message="Are you sure you want to delete this regional modifier?"
        />
      )}
    </div>
  );
};

export default PartnerRegionalMultipliers;